import { MMDRIVERS } from './url';
import { FETCH_MMDRIVERS, FETCH_MMDRIVER } from '../actions/type';
import axios from 'axios';

function fetchMMDriversSuccess(data) {
  return {
    type: FETCH_MMDRIVERS,
    payload: data,
  }
}

export function fetchMMDriversByTime(from, to) {
 return (dispatch) => {
  axios.get(
   `${MMDRIVERS}?update_time__gt=${from}&update_time__lt=${to}`,
   {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
   },
  )
   .then(res => {
    dispatch(fetchMMDriversSuccess(res.data));
   }, (err) => {
    // if (err.status === 500 || err.status === 404) {
    //  err.data = DEFAULT_ERROR;
    // }
   });
 };
}

export function editDriverInfomation(data) {
  return (dispatch) => {
    axios.put(
      `${MMDRIVERS}${data.driver_id}`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
    .then(res => {
      window.location.reload(false);
    })
    .catch(err => {
      console.log('err catching', err);
    })
  }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/mmdriver-actions.js